import React from 'react';
import { useLocation, useNavigate } from '../nav';
import { CustomIcon } from './CustomIcons';
import { VeeMascot } from './VeeMascot';
export function BottomNav() {
  const navigate = useNavigate();
  const {
    pathname
  } = useLocation();
  const path = pathname.split('?')[0];
  const item = (label: string, icon: 'home' | 'history' | 'bills' | 'profile', to: string) => {
    const active = path === to;
    return <button type="button" onClick={() => navigate(to)} aria-current={active ? 'page' : undefined} className={`flex w-[60px] flex-col items-center justify-center gap-1.5 transition-colors ${active ? 'text-brand-cobalt' : 'text-slate-400 hover:text-brand-navy'}`} data-id="element-34" data-mp="2st7g8grbzqiu">
        <CustomIcon name={icon} size={24} data-id="element-35" data-mp="2etomisz9ohq2" />
        <span className="text-[10px] font-extrabold" data-id="element-36" data-mp="2eupzj2zufeaf">{label}</span>
      </button>;
  };
  return <nav aria-label="Primary navigation" className="sticky inset-x-0 bottom-0 z-40 mt-auto flex h-[88px] shrink-0 items-start justify-between border-t border-slate-200 bg-white/95 px-4 pt-3 backdrop-blur-xl" data-id="element-37" data-mp="hxqrylw3lnlo">
      {item('Home', 'home', '/home')}
      {item('History', 'history', '/history')}
      
      <button type="button" onClick={() => navigate('/chat')} aria-label="Open Vee" className="flex w-[60px] flex-col items-center justify-center gap-1.5" data-id="element-38" data-mp="3v57to8r97zoz">
        <span className={`flex h-8 w-12 items-center justify-center rounded-full transition-colors ${path === '/chat' ? 'bg-brand-cobalt' : 'bg-[#061827]'}`} data-id="element-39" data-mp="roiw3c9ng0bg">
          <VeeMascot size={22} state={path === '/chat' ? 'listening' : 'idle'} data-id="element-40" data-mp="wn2krkfmnq7i" />
        </span>
        <span className={`text-[10px] font-extrabold ${path === '/chat' ? 'text-brand-cobalt' : 'text-brand-navy'}`} data-id="element-41" data-mp="hxwjzs155rxi">Vee</span>
      </button>

      {item('Bills', 'bills', '/bills')}
      {item('Profile', 'profile', '/profile')}
    </nav>;
}